export default "__VITE_ASSET__BP8JK7bY__"